export default [
    {
      path: '/',
      redirect: '/login',
      // meta: {
      //   title: '登录'
      // }
    },
    
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/login/index'),
      meta: {
        title: '意健险'
      }
    },

    {
      path: '/login2',
      name: 'login2',
      component: () => import('@/views/login/login2'),
      meta: {
        title: '意健险'
      }
    },
    
    {
      path: '/main',
      name: 'main',
      component: () => import('@/views/main/index'),
      meta: {
        title: '意健险'
      },
    },

    {
      path: '/doubtCourseDetail',
      name: 'doubtCourseDetail',
      component: () => import('@/views/main/anxinCase/doubtCourseDetail'),
      meta: {
        title: '意健险-调查过程详情'
      },
    },

    {
      path: '/caseDetail',
      name: 'caseDetail',
      component: () => import('@/views/main/anxinCase/taskDetail'),
      meta: {
        title: '意健险-案件详情'
      },
    },
    
    {
      path: '/caseDetailinsup',
      name: 'caseDetailinsup',
      component: () => import('@/views/main/anxinCase/taskDetailinsup'),
      meta: {
        title: '意健险-案件详情'
      },
    },
    {
      path: '/caseJGDetail',
      name: 'caseJGDetail',
      component: () => import('@/views/main/anxinCaseJG/detail'),
      meta: {
        title: '意健险-案件详情'
      },
    },
    {
      path: '/caseRYDetail',
      name: 'caseRYDetail',
      component: () => import('@/views/main/anxinCaseRY/detail'),
      meta: {
        title: '意健险-案件详情'
      },
    },
    
    {
      path: '/muchWorkAuditDetail',//多地作业审核详情
      name: 'muchWorkAuditDetail',
      component: () => import('@/views/main/anxinCase/muchWorkAuditDetail'),
      meta: {
        title: '意健险-多地作业审核详情'
      },
    },

    {
      path: '/ZYDetail',//安心案件管理-任务详情
      name: 'ZYDetail',
      component: () => import('@/views/main/anxinCaseJG/ZYDetail'),
      meta: {
        title: '意健险-安心案件管理-案件详情',
        // keepAlive: true // 需要缓存
      },
    },

]
  